"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var axios_1 = tslib_1.__importDefault(require("axios"));

var BFP = tslib_1.__importStar(require("@douyin-web/browser-finger-print"));

var timeout = 3000;
var config = {
  timeout: timeout,
  withCredentials: true,
  headers: {
    'content-type': 'application/x-www-form-urlencoded'
  }
};
/**
 * s收集浏览器特征值
 * @returns  { Promise<FingerprintInfo> }
 */

exports.collectFingerprintInfo = function () {
  return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var components, values, hash;
    return tslib_1.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , BFP.get()];

        case 1:
          components = _a.sent();
          values = {};
          hash = BFP.hashComponents(components);
          Object.keys(components).forEach(function (key) {
            values[key] = components[key].value || '';
          });
          return [2
          /*return*/
          , {
            info: values,
            id: hash
          }];
      }
    });
  });
};

var reportInfo = function (option) {
  return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var aid, _a, host, _b, info, id, res, error_1;

    return tslib_1.__generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          aid = option.aid, _a = option.host, host = _a === void 0 ? '' : _a;
          _c.label = 1;

        case 1:
          _c.trys.push([1, 5,, 6]);

          return [4
          /*yield*/
          , exports.collectFingerprintInfo()];

        case 2:
          _b = _c.sent(), info = _b.info, id = _b.id;
          if (!(id && info)) return [3
          /*break*/
          , 4];
          return [4
          /*yield*/
          , axios_1.default.post(host + "/ttwid/report_fingerprint/", {
            aid: aid,
            fingerprint_values: info,
            fingerprint_id: id
          }, config)];

        case 3:
          res = _c.sent();

          if (res.data.status_code !== 0) {
            throw new Error(res.data.message);
          }

          return [2
          /*return*/
          , res.data || res];

        case 4:
          throw new Error('获取指纹信息失败');

        case 5:
          error_1 = _c.sent();
          console.error(error_1);
          throw error_1;

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  });
};

var requestIdleCallback = function (func) {
  if (typeof window !== 'undefined' && window.requestIdleCallback) {
    window.requestIdleCallback(func);
  } else {
    setTimeout(func, 50);
  }
};

exports.reportFingerprintInfo = function (option) {
  requestIdleCallback(function () {
    reportInfo(option);
  });
};